import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { MapPin, Clock, Users, PhoneCall } from 'lucide-react';
import { Button } from "@/components/ui/button";
import PageHeader from '@/components/PageHeader';
import LogoScroller from '@/components/LogoScroller';
import { ScheduleHeader } from './ScheduleHeader';
import { DayTabs } from './DayTabs';

const ScheduleSection: React.FC = () => {
  // Function to handle bottom tab click
  const handleDayTabClick = (day: string) => {
    if (day === 'day2') {
      // Navigate to the specific URL for day 2 and scroll to top
      window.location.href = 'https://aiconference.london/agenda#day2';
      // Scroll to top of page
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    
    // Find the tabs component in DayTabs and click the appropriate tab
    const tabElement = document.querySelector(`[value="${day}"]`) as HTMLElement;
    if (tabElement) {
      tabElement.click();
    }
    
    // Scroll to schedule section
    const scheduleSection = document.getElementById('schedule');
    if (scheduleSection) {
      scheduleSection.scrollIntoView({ behavior: 'smooth' });
    }
    
    // Update URL hash for direct linking
    window.history.pushState(null, '', `#${day}`);
  };

  const handleDay2Click = () => {
    // First scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // Then navigate after a brief delay to ensure smooth scroll completes
    setTimeout(() => {
      window.location.href = 'https://aiconference.london/agenda#day2';
    }, 100);
  };

  return (
    <section className="mx-auto px-4 py-12 md:max-w-[70%]">
      <ScheduleHeader />
      <DayTabs />
      
      {/* Bottom date tabs */}
      <div className="mt-6">
        {/* Date tabs at bottom */}
        <div className="w-full mb-4">
          <div className="grid grid-cols-2 w-full">
            <button 
              onClick={() => handleDayTabClick('day1')}
              className="text-white bg-green-600 data-[state=active]:bg-green-600 data-[state=active]:text-white py-2.5 text-base font-medium text-center cursor-pointer hover:bg-green-700 transition-colors"
            >
              November 25th
            </button>
            <button 
              onClick={handleDay2Click}
              className="text-white bg-blue-600 data-[state=active]:bg-blue-700 data-[state=active]:text-white py-2.5 text-base font-medium text-center cursor-pointer hover:bg-blue-700 transition-colors"
            >
              November 26th
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScheduleSection;
